import { useEffect, useState, useMemo } from "react";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs"
import KodeRekening from "./KodeRekening";
import KodeBarang from "./KodeBarang";

export default function Kode() {
  return (
    <div className="container pt-12 mb-12">
      <div className="p-6 space-y-6 bg-white p-4 shadow rounded-xl">
        <div className="flex flex-row items-center gap-2">
          <img className="w-[32px] md:w-[52px] h-fit" src="/bidangasset.svg" />
          <h1 className="text-2xl font-bold">Kode E-BMD</h1>
        </div>

        <Tabs defaultValue="kodebarang">
          <TabsList>
            <TabsTrigger value="kodebarang">Kode Barang</TabsTrigger>
            <TabsTrigger value="koderekening">Kode Rekening</TabsTrigger>
          </TabsList>
          <TabsContent value="kodebarang">
            <KodeBarang />
          </TabsContent>
          <TabsContent value="koderekening">
            <KodeRekening />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}